import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { CustomerForecastRepository } from '@/coreInfrastructureModule/Repositories/CustomerForecastRepository';
import { ICustomerForecastRepository } from '@/coreInfrastructureModule/interfaces/ICustomerForecastRepository';
import { CustomerForecastFilterItem } from '@/coreInfrastructureModule/axios/generated/customerForecastManage';
import { ILongTermCustomerForecastResult } from '@/recommendOrderModule/domains/entities/longTermCustomerForecast';
import { LongTermCustomerForecastAdapter } from '@/recommendOrderModule/adapters/longTermCustomerForecastAdapter';
import { DateService } from '@/coreDomainsModule/services/dateService';

/**
 * 長期間の客先内示を取得するための UseCase
 */
export class GetLongTermCustomerForecastUseCase {
  /**
   * 客先内示取得用リポジトリ
   */
  private readonly customerForecastRepo: ICustomerForecastRepository;

  /**
   * コンストラクタ
   */
  constructor() {
    this.customerForecastRepo = new CustomerForecastRepository();
  }

  /**
   * 未来24ヶ月分の仕入先内示データを取得する
   * @param businessId - 取得対象の取引ID
   * @returns 取得した仕入先内示データ
   */
  async execute(businessId: string): Promise<INetworkResult<ILongTermCustomerForecastResult, IError>> {
    try {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth() + 1; // getMonth()は0-11なので+1

      const startYearMonth = DateService.convertDateToIYearMonth(today);
      const endYearMonth = DateService.getShiftedIYearMonthByMonths(currentYear, currentMonth, 23);

      const filterItem: CustomerForecastFilterItem = {
        aggregateBusinessId: businessId,
      };

      const result = await this.customerForecastRepo.getLongterm(
        startYearMonth.year,
        startYearMonth.month,
        endYearMonth.year,
        endYearMonth.month,
        100, // limit
        0, // offset
        filterItem
      );

      if (result.status.type === 'success') {
        const convertedResult = LongTermCustomerForecastAdapter.adapt(result.status.data);
        return {
          status: {
            type: 'success',
            data: convertedResult,
          },
        };
      } else {
        return {
          status: {
            type: 'error',
            error: result.status.error,
          },
        };
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: error as IError,
        },
      };
    }
  }
}
